import "./App.css";
import About from "./components/common/About";
import Community from "./components/common/Community";
import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Footer from "./components/common/Footer";
import Header from "./components/common/Header";
import Hero from "./components/common/Hero";
import HowToBuy from "./components/common/HowToBuy";
import Network from "./components/common/Network";
import Roadmap from "./components/common/Roadmap";
import Slider from "./components/common/Slider";
import Takeoff from "./components/common/Takeoff";
import Tokenomics from "./components/common/Tokenomics";

function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000, // Animation duration
      easing: "ease-in-out", // Animation easing
      once: false, // Whether animation should happen only once
    });
  }, []);
  return (
    <>
      <div className="overflow-x-hidden ">
        <div className="main-bg">
          <Header />
          <Hero />
        </div>
        <Slider />
        <About />
        <Network />
        <Takeoff />
        <HowToBuy />
        <Tokenomics />
        <Roadmap />
        <div>
          <Community />
          <Footer />
        </div>
      </div>
    </>
  );
}

export default App;
